import axios from 'axios';
import i18n from 'i18next';

export default function axiosConfig() {
    // Defaults for axios
    axios.defaults.baseURL = import.meta.env.VITE_API_URL;
    axios.defaults.headers.common.Accept = 'application/json';
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    axios.defaults.headers.common['Accept-Language'] =
        i18n.language === 'en' ||
        i18n.language === 'de' ||
        i18n.language === 'fr'
            ? i18n.language
            : 'en';
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
    axios.defaults.xsrfCookieName = 'csrftoken';
}
